export const Types = {
  SAVE_HISTORY: "SAVE_HISTORY",
};
